const buildQueryKey = (key, listName) => {
  const listNameKey = listName ? `pb[${listName}]` : '';
  const wrappedSearchKey = listNameKey ? `[${key}]` : key;
  return `${listNameKey}${wrappedSearchKey}`;
};

export default buildQueryKey;
